<template>
  <Layout>
    <ModalDeleteServiceTributes />
    <Title
      title="Tributações"
      :hasNewRegister="true"
      :routeNewRegister="handleNavigationRegister"
    />
    <Table
      :key="tableKey"
      :tableData="tableData"
      :items="summaryServiceTributes"
      :pagination="true"
      :perPage="paginationServiceTributes.perPage"
      :startItem="paginationServiceTributes.startItem"
      :endItem="paginationServiceTributes.endItem"
      :totalItems="paginationServiceTributes.totalItems"
      :page="paginationServiceTributes.currentPage"
      :onClickRow="handleRowClick"
      :onSearch="search"
      @changeItemsPerPage="changeItemsPerPage"
      @changePage="changePage"
    />
  </Layout>
</template>

<script>
import { Layout, Title, Table, TableData, Actions } from '@/components';
import { mapActions, mapState } from 'vuex';
import ModalDeleteServiceTributes from './components/modals/ModalDeleteServiceTributes.vue';

export default {
  name: 'ServiceTributes',
  components: {
    Layout,
    Title,
    Table,
    ModalDeleteServiceTributes,
  },
  data() {
    return {
      tableKey: 0,
    };
  },
  async mounted() {
    await this.resetServiceTributesState();

    try {
      this.setLoading(true);
      await this.setSummaryServiceTributes({
        pagination: this.paginationServiceTributes,
      });
    } finally {
      this.setLoading(false);
    }
  },
  computed: {
    ...mapState('nfseTributes', [
      'summaryServiceTributes',
      'paginationServiceTributes',
      'warnings',
    ]),
    ...mapState('nfseTributesComponents', ['modalDeleteServiceTributesIsOpen']),
    tableData() {
      const { Data, TABLE_CELL_ALIGN } = TableData;
      const DataTable = new Data({
        panelActions: true,
        panelActionsSearch: true,
        select: true,
        titleMobile: (item) => item.description,
        onSearch: this.search,
      });

      DataTable.addField({
        key: 'description',
        label: 'Descrição',
      })
        .addField({
          key: 'issPercentage',
          label: '% ISS',
          width: 200,
          formatter: (value) =>
            new Intl.NumberFormat('pt-BR', {
              style: 'decimal',
              minimumFractionDigits: 4,
            }).format(value),
        })
        .addField({
          align: TABLE_CELL_ALIGN.center,
          key: 'baseIssPercentage',
          label: '% Base ISS',
          width: 200,
          formatter: (value) =>
            new Intl.NumberFormat('pt-BR', {
              style: 'decimal',
              minimumFractionDigits: 4,
            }).format(value),
        })
        .addActions(Actions('delete', (selected) => this.delete(selected)));
      return DataTable;
    },
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    ...mapActions('nfseTributes', [
      'resetServiceTributesState',
      'setSummaryServiceTributes',
    ]),
    ...mapActions('nfseTributesComponents', [
      'setModalDeleteServiceTributesIds',
      'toggleModalDeleteServiceTributes',
    ]),
    handleRowClick(item) {
      this.$router.push(`/fiscal/nfse/tributes/edit/${item.id}`);
    },
    async search(value) {
      await this.setLoading(true);
      await this.setSummaryServiceTributes({
        search: value,
        pagination: { ...this.paginationServiceTributes, currentPage: 1 },
      });
      await this.setLoading(false);
    },
    async handleNavigationRegister() {
      return this.$router.push({ name: 'ServiceTributesRegister' });
    },
    async changeItemsPerPage(items) {
      const pagination = {
        ...this.paginationServiceTributes,
        perPage: items,
        currentPage: 1,
      };
      await this.setLoading(true);
      await this.setSummaryServiceTributes({ pagination });
      await this.setLoading(false);
    },
    async changePage(page) {
      const pagination = {
        ...this.paginationServiceTributes,
        currentPage: page,
      };
      await this.setLoading(true);
      await this.setSummaryServiceTributes({ pagination });
      await this.setLoading(false);
    },
    delete(selected) {
      this.setModalDeleteServiceTributesIds(selected);
      this.toggleModalDeleteServiceTributes();
    },
  },
  watch: {
    modalDeleteServiceTributesIsOpen() {
      if (!this.modalDeleteServiceTributesIsOpen) {
        this.tableKey += 1;
        this.warnings.splice(0, this.warnings.length);
      }
    },
  },
};
</script>
